// import 'suneditor/dist/css/suneditor.min.css';
import 'suneditor/src/assets/css/suneditor.css'
import 'suneditor/src/assets/css/suneditor-contents.css'
import suneditor from 'suneditor';
import lang from 'suneditor/src/lang';
import {font, link, list } from 'suneditor/src/plugins';

import './styles/index.scss';

class Editor {
    _elements = [];

    init = (selector) => {
        const options = {
            plugins: [
                font, link, list
            ],
            buttonList: [
                ['bold', 'underline', 'italic', 'link', 'list'],
            ],
            resizeEnable: true,
            linkNoPrefix: false,
            linkTargetNewWindow: true,
            linkProtocol: 'http://'
        };

        this._elements = [
            ...document
                .querySelectorAll(selector)
        ]
            .map(element => {
                const editor = suneditor.create(element, {
                    ...options,
                    placeholder: element.placeholder,
                    lang: lang[element.dataset.locale] ?? lang['en'],
                    height: element.dataset.height ?? "4rem"
                });

                editor.onChange = (contents) => {
                    element.value = contents;
                }

                return {
                    editor,
                    element
                };
            });

        return this;
    }

    findEditor = (node) => {
        if(!this._isElement(node))
            return false;

        return this._elements
            .find(element => node.isSameNode(element.element))
            ?.editor;
    }

    getContentFromEditor = (element) => this.findEditor(element)?.getContents();

    setContentForEditor = (element, value) => this.findEditor(element)?.setContents(value);

    clearEditor = (element) => this.setContentForEditor(element, '');

    _isElement = (node) => (typeof HTMLElement === "object" ? node instanceof HTMLElement : //DOM2
        node && typeof node === "object" && node.nodeType === 1 && typeof node.nodeName==="string")
}

export default new Editor();
